<!-- receiveCoupon -->
<template>
  <div class="receiveCoupon">
    <common-title titleName="启航教育-领取优惠券"></common-title>
    <p class="couponTips">恭喜你获得一张优惠券</p>
    <div
      class="countDownBox"
      v-if="showTime"
    >
      <div class="countDownCenter">
        限时抢券：{{showTime}}
      </div>
    </div>
    <coupon-card
      :orderType="true"
      :couponInfo="couponInfo"
      :valid="couponValid"
      :couponStatus="couponStatus"
      :receiveCoupon='true'
    />
    <p class="leftTips">
      剩余<span>{{ couponInfo.couponNum }}</span>张可领
    </p>
    <button
      v-if="(couponInfo.couponNum && couponInfo.linkGetTime !== 2 && couponInfo.linkExpire===1) ||
            (couponInfo.couponNum === 0 && couponInfo.alreadyGet && couponInfo.linkExpire===1)"
      :class="['receiveButton', { cantReceive: !couponValid || !inited }]"
      @click="couponReceive"
    >
      {{ couponInfo.alreadyGet&&couponInfo.couponUseStatus===1?'去使用':'点击领取'}}
    </button>
    <p class="cantTips">{{ cantTips ? cantTips : '' }}</p>
    <section class="receiveTips">
      <p class="tipsTitle">领取说明</p>
      <p class="tipsInfo">1、优惠券领取成功后请到启航教育App-“我的”-“优惠券”中查看。</p>
      <p class="tipsInfo">
        2、领取遇到问题？请联系 <a
          href="tel:400-108-7500"
          class="phoneNumber"
        >400-108-7500</a>
      </p>
    </section>
    <section
      class="bottomArea"
      v-show="!this.$root.$data.isApp"
    >
      <p class="companyName"></p>
      <div class="appInfo">
        <p class="appName">启航教育APP</p>
        <p class="appDescription">免费下载课程视频，听课更流畅</p>
      </div>
      <button
        @click="goApp"
        class="goApp"
      >前往APP</button>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import CommonTitle from '@/components/header/CommonTitle.vue';
// eslint-disable-next-line import/no-cycle
import { reqCouponInfo, reqReceiveCoupon } from '@/api/coupon';
import {
  gioPlatform, setBaseUrl, replaceHyphens, timerYhqCount,
} from '@/utils/tools';
import CouponCard from '../../components/coupon/CouponCard.vue';
import wx from 'weixin-js-sdk';

export default {
  data() {
    return {
      leftNumber: 0,
      couponInfo: {},
      cantTips: '',
      couponId: '',
      versionId: '',
      formatter: 'YYYY-MM-DD HH:mm:ss',
      couponValid: true,
      receiving: false,
      alreadyRecevied: false,
      inited: false,
      currentTime: moment(),
      timeDiff: 0,
      couponDetail: {},
      couponStatus: '',
      showTime: '',
      timers: null,
      couponEndTime: '',
      couponStartTime: '', // 优惠券开始领取时间
    };
  },
  components: {
    CommonTitle,
    CouponCard,
  },
  watch: {
    currentTime(val) {
      if ((this.couponInfo?.couponNum || 0) <= 0 || this.alreadyRecevied) return;
      if (!this.couponInfo?.startDateTime || !this.couponInfo?.endDateTime) {
        return;
      }
      this.validCalc(val);
    },
  },
  mounted() {
    this.couponId = this.$route?.query?.couponId || '';
    this.versionId = this.$route?.query?.versionId || '';
    this.couponInfoInit();
    // this.timeCountdown();
  },
  methods: {
    couponInfoInit() {
      if (!this.couponId || !this.versionId) return;
      const userId = this.$store?.state?.userInfo?.id;
      reqCouponInfo({
        couponId: String(this.couponId),
        couponVersion: Number(this.versionId),
        userId,
      })
        .then((response) => {
          if (response?.code) {
            this.$toast(`因${response?.msg}优惠券信息初始化失败`);
          } else {
            this.inited = true;
            let couponInfo = response?.data || {};
            couponInfo = response?.data || {};
            couponInfo.startDateTime = moment(couponInfo?.effectiveTimeBegin);
            couponInfo.endDateTime = moment(couponInfo?.effectiveTimeEnd);
            couponInfo.receiveStart = moment(couponInfo?.receiveTimeBegin);
            couponInfo.receiveEnd = moment(couponInfo?.receiveTimeEnd);
            if (couponInfo.effectiveTimeType === 1) {
              couponInfo.dateTimeInfo = `领取后${couponInfo.effectiveDays}天有效`;
            } else if(couponInfo.effectiveTimeType === 2) {
              couponInfo.dateTimeInfo = `${couponInfo.startDateTime.format(
                this.formatter,
              )} 至 ${couponInfo.endDateTime.format(this.formatter)}`;
            } else if(couponInfo.effectiveTimeType === 3) {
              couponInfo.dateTimeInfo = `领取后当天有效`
            } else if(couponInfo.effectiveTimeType === 4) {
              couponInfo.dateTimeInfo = `领取后${couponInfo.effectiveHours}小时内有效`
            }
            this.couponInfo = couponInfo;
            this.couponDetail = response.data;
            this.currentTime = response?.currentTime;
            this.couponEndTime = couponInfo.receiveTimeEnd;
            this.couponStartTime = couponInfo.receiveTimeBegin;
            this.countTime();
            this.validCalc(this.currentTime);
          }
        })
        .catch(() => {
          this.$toast('优惠券信息初始化失败');
        });
    },
    validCalc(current) {
      const currentMoment = moment(current);
      if (currentMoment > this.couponInfo.endDateTime) {
        this.couponValid = false;
        this.cantTips = '优惠券已过期，下次请早点来哦~';
      } else if (currentMoment > this.couponInfo.receiveEnd) {
        this.couponValid = false;
        this.cantTips = '优惠券领取已到期限，下次请早点来哦~';
      } else if (currentMoment < this.couponInfo.receiveStart) {
        this.couponValid = false;
        this.couponStatus = 'notStart';
        this.cantTips = this.couponDetail.receiveTimeBegin ? `${this.couponDetail.receiveTimeBegin} 可以领取` : '活动尚未开始';
      } else if (this.couponInfo.couponNum <= 0) {
        this.couponValid = false;
        this.cantTips = '优惠券已经被领完了，下次请早点来哦~';
      } else if (this.couponInfo.linkExpire === 0) {
        // 已领取未使用已过期
        this.couponValid = false;
        this.cantTips = '优惠券已过期，下次请及时使用呦~';
      } else if (this.couponInfo.couponUseStatus === 2) {
        this.couponValid = false;
        this.cantTips = '优惠券已使用，看看其他优惠券吧~';
      } else {
        this.couponValid = true;
        this.cantTips = false;
      }
    },
    // 倒计时
    countTime() {
      // 当前时间戳
      const now = new Date(replaceHyphens(this.currentTime)).getTime() || new Date().getTime();
      // 结束时间戳
      const end = new Date(replaceHyphens(this.couponEndTime)).getTime();
      // 优惠券开始领取的时间
      const begin = new Date(replaceHyphens(this.couponStartTime)).getTime();
      if (begin > now) {
        this.showTime = null;
        return;
      }
      // 做判断当倒计时结束时都为0
      if (now >= end) {
        this.showTime = null;
        return;
      }
      // 用结束时间减去当前时间获得倒计时时间戳
      let temp = end - now + 1000;
      this.timers = setInterval(() => {
        temp -= 1000;
        if (temp > 0) {
          this.showTime = timerYhqCount(temp);
        } else {
          console.log(temp);
          this.showTime = null;
          clearInterval(this.timers);
        }
      }, 1000);
    },

    // couponCheck() {
    //   reqCheckCoupon({
    //     couponId: Number(this.couponId),
    //     couponVersion: Number(this.versionId),
    //   }).then((response) => {
    //     if (response?.code) {
    //       this.couponValid = false;
    //       this.alreadyRecevied = true;
    //       this.cantTips = '这个优惠券你已经领取过了，不能重复领取哦～';
    //     }
    //   });
    // },
    couponReceive() {
      if (this.$root.miniprogram&&!this.$store?.state?.userInfo?.id) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if(searchParams){
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
             const [key, value] = item.split('=');
            //  console.log('key', key, value);
             if (key) {
               paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
            for (const [key, value] of entries) {
               if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
            }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
              url: path,
           });
        }
        return false;
      }else if (!this.$store?.state?.userInfo?.id) {
        const param = { redirect: '/receiveCoupon', ...this.$route.query };
        this.$router.push({ path: '/registrationLogin', query: param });
        return;
      }
      // 已经领取点击去使用
      if (this.couponInfo?.alreadyGet) {
        this.goPage();
        return;
      }
      if (!this.couponValid && this.inited) {
        this.$toast(this.cantTips);
      }
      if (!this.couponId || !this.versionId || !this.couponValid || this.receiving || !this.inited) return;

      this.receiving = true;
      reqReceiveCoupon({
        couponId: String(this.couponId),
        couponVersion: Number(this.versionId),
        isPrivateCoupon: 1,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark
      })
        .then((response) => {
          this.receiving = false;
          if (response?.code === 0) {
            this.$toast('领取成功');
            this.couponValid = false;
            this.couponInfo.couponNum -= 1;
            this.alreadyRecevied = true;
            this.$forceUpdate();
            this.gioEvent();
            this.couponInfoInit();
          } else this.$toast(`领取失败 ${response?.msg}`);
        })
        .catch((e) => {
          this.$toast(`领取失败 ${e}`);
        });
    },
    // timeCountdown() {
    //   setInterval(() => {
    //     this.currentTime = moment() + this.timeDiff;
    //   }, 1000);
    // },
    goApp() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'https://itunes.apple.com/cn/app/id1172161344';
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      } else {
        const loadDateTime = Date.now();
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'iqihanglmh5://';
          const turnIOS = setTimeout(() => {
            const timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 2200) {
              window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
            } else {
              clearTimeout(turnIOS);
            }
          }, 2000);
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      }
    },
    goPage() {
      const { productionFitType ,packageFitType} = this.couponInfo;
      let routeUrl = '';
      // 适用产品类型 1 所有产品 2 限定产品 3 限定产品分类 4 所有套餐 5 限定套餐
      if (productionFitType === 1 || productionFitType === 4||packageFitType===4) {
        // 判断是否App
        if (this.$root.$data.isApp) {
          this.$sendToApp('goToHomePage');
          return;
        }
        if (this.$root.$data.miniprogram) {
          console.log(33333)
          wx.miniProgram.switchTab({ url: '/pages/home/home' });
          return;
        }
        this.$router.push({
          path: '/home',
          query: {
            code: 2,
          },
        });
        return;
      }
      if(packageFitType===5&&(productionFitType===2||productionFitType===3)){
         const { productIds ,productCatalogIds,packageIds} = this.couponInfo;
         const productId = productIds?.join();
         const productCategoryId = productCatalogIds?.join();
         const packageId = packageIds?.join();
        if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/limitProduct?productionFitType=${productionFitType}&packageFitType=${packageFitType}&productIds=${productId}&productCategoryIds=${productCategoryId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/limitProduct',
            query: {
              productionFitType,
              packageFitType,
              productIds:productId,
              productCategoryIds:productCategoryId,
              packageIds:packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        return
      }
      if (productionFitType === 2) {
        const { productIds } = this.couponInfo;
        if (productIds.length > 1) {
          const productId = productIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/productList?type=5&productId=${productId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/productList',
            query: {
              type: 5,
              productId,
            },
          });
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goCourseDetail', Number(productIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/courseDetail',
            query: {
              courseId: productIds[0],
            },
          });
        }
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 3) {
        const { productCatalogIds } = this.couponInfo;
        const productCategoryId = productCatalogIds.join();
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            { url: `${setBaseUrl('')}/ark/productList?type=3&productCategoryId=${productCategoryId}` },
            false,
          );
          return;
        }
        routeUrl = this.$router.resolve({
          path: '/productList',
          query: {
            type: 3,
            productCategoryId,
          },
        });
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 5||packageFitType===5) {
        const { packageIds } = this.couponInfo;
        if (packageIds.length > 1) {
          const packageId = packageIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/combinationList?packageIds=${packageId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationList',
            query: {
              packageIds: packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goToCombinationCourse', Number(packageIds[0]), false);
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationCourse',
            query: {
              combinationId: packageIds[0],
            },
          });
          window.open(routeUrl.href, '_blank');
        }
      }
    },
    gioEvent() {
      const {
        couponId,
        couponName,
        discountType,
      } = this.couponDetail;
      // eslint-disable-next-line
      let disType = discountType === 1 ? '满减' : discountType === 2 ? '打折' : null;
      // 领取优惠券
      // eslint-disable-next-line
      gio('track', 'getCoupon_event', {
        getPage_var: '卡券分享页面',
        courseId_var: null, // 在课程详情页领取的卡券，该变量才会有值
        couponIdList_var: couponId,
        couponTypeList_var: disType, // 卡券类型列表
        couponNameList_var: couponName,
        platform_var: gioPlatform(),
      });
    },

  },
  destroyed() { clearInterval(this.timers); },
};
</script>

<style lang="scss" scoped>
.receiveCoupon {
  flex: 1;
  width: 100%;
  padding: 149px 36px 335px;
  background: #f9f9f9;

  .couponTips {
    height: 45px;
    margin-bottom: 48px;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;
    text-align: center;
  }
  .countDownBox {
    margin-bottom: 30px;
    text-align: center;
    .countDownCenter {
      color: #ff6c02;
      font-size: 28px;
    }
  }

  .leftTips {
    height: 31px;
    margin-top: 29px;
    color: #787878;
    font-weight: 400;
    font-size: 22px;
    line-height: 31px;
    text-align: center;

    span {
      margin: 0 14px;
      color: #ff6c02;
    }
  }

  .cantTips {
    height: 36px;
    margin-top: 29px;
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
    text-align: center;
  }

  .receiveButton {
    display: block;
    width: 634px;
    height: 91px;
    margin: 72px  auto;
    color: #fff;
    font-weight: 500;
    font-size: 36px;
    line-height: 91px;
    background: #ff6c02;
    border-radius: 45px;

    &:active {
      background: #ff984d;
    }

    &.cantReceive {
      background: #ccc;
    }
  }

  .receiveTips {
    position: fixed;
    right: 0;
    bottom: 109px;
    left: 0;
    width: 750px;
    margin: 0 auto;
    background: #f9f9f9;

    .tipsTitle {
      height: 40px;
      margin-bottom: 29px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      // font-family: PingFangSC-Medium, PingFang SC;
      line-height: 40px;
    }

    .tipsInfo {
      height: 72px;
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      // font-family: PingFangSC-Regular, PingFang SC;
      line-height: 36px;

      .phoneNumber {
        color: #ff6c02;
      }
    }
  }

  .bottomArea {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 109px;
    background: #fefffe;
    box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

    .companyName {
      width: 161px;
      height: 49px;
      margin: 0 22px 0 24px;
      background: url('../../assets/img/footer/footer_icon.png') no-repeat center center;
      background-size: contain;
    }

    .appInfo {
      .appName {
        height: 36px;
        margin-bottom: 7px;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
      }

      .appDescription {
        height: 31px;
        color: #787878;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
      }
    }

    .goApp {
      position: absolute;
      top: 20px;
      right: 36px;
      height: 67px;
      padding: 0 16px;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 67px;
      text-align: center;
      background: #ff6c02;
      border-radius: 34px;
      cursor: pointer;

      &:active {
        background: #ff984d;
      }
    }
  }
}
</style>
